import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../assets/styles/custom.styl'
// import 'vuetify/src/stylus/app.styl';
import "@mdi/font/css/materialdesignicons.css";

import colors from 'vuetify/es5/util/colors'
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    secondary: "#d6ce15",
    primary: colors.green,
    done: colors.lightGreen,
    seen: colors.lime,
    active: colors.amber.lighten2,
    pending: colors.amber.lighten3,
    confirmed: colors.lightGreen.lighten2,
    paid: colors.amber,
    rejected: colors.red.accent3,
  },
})
